export default __webpack_public_path__ + "static/media/OwlPage2.a6b1bc01.txt";